module.exports = __webpack_public_path__ + "static/media/code.67e02430.svg";